/* nv-cart.js : 28/10/2026. Comportements du tiroir panier natif (sections/cart-drawer.liquid).
   - rafraichit le tiroir via /?section_id=cart-drawer apres chaque ecriture panier (Section Rendering API) ;
   - ouvre le tiroir apres un ajout (data-open-on-add), au clic sur l'icone sac et sur tout lien /cart ;
   - minuteur en boucle (identique Moonbundle, decision Ilyes 28/10), compteur du sac [data-cart-count] ;
   - compteur − n + par ligne, corbeille, changement de variante (culotte, pois), upsells a interrupteur avec photo par couleur et taille du reggiseno ;
   - « Cambia taglia o colore » ferme le tiroir et ramene au bloc d'offres (le nouvel ajout remplace l'ancien lot).
   Toutes les ecritures passent par window.fetch (nv-v4.js l'enveloppe pour resynchroniser les attributs UTM). */
(function () {
  if (window.__nvCartJs) return; window.__nvCartJs = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function dlg() { return document.getElementById('CartDrawer'); }
  function isOpen() { var d = dlg(); return !!(d && d.open); }
  function open() { var d = dlg(); if (!d || typeof d.showModal !== 'function' || d.open) return; try { d.showModal(); } catch (e) {} }
  function close() { var d = dlg(); if (d && d.open) d.close(); }

  var seq = 0;
  function applyHtml(html, openAfter) {
    var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.getElementById('CartDrawer'), cur = dlg();
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      cur.setAttribute('data-open-on-add', fresh.getAttribute('data-open-on-add') || 'true');
      cur.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
    }
    var c = doc.querySelector('[data-nv-count-src]'); if (c) badge(c.textContent.trim());
    if (cur) cur.classList.remove('is-loading');
    if (openAfter && cur && cur.getAttribute('data-open-on-add') !== 'false') open();
  }
  function refresh(openAfter) {
    var my = ++seq;
    return new Promise(function (resolve) {
      var d = dlg(); if (d) d.classList.add('is-loading');
      fetch('/?section_id=cart-drawer', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (html) {
        if (my !== seq) return resolve();
        applyHtml(html, openAfter); resolve();
      }).catch(function () { var cur = dlg(); if (cur) cur.classList.remove('is-loading'); resolve(); });
    });
  }
  /* HTML de la section deja recu avec la reponse de /cart/add.js ou /cart/update.js (option sections) : zero requete en plus */
  function refreshFromHtml(html, openAfter) { seq++; try { applyHtml(html, openAfter); } catch (e) { refresh(openAfter); } }
  function badge(n) { n = Number(n) || 0; $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; }); }
  function badgeFromApi() { fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { badge(c.item_count); }).catch(function () {}); }
  window.nvCartBadge = badgeFromApi;

  function post(url, body) {
    return window.fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function change(key, qty) { return post('/cart/change.js', { id: key, quantity: qty }); }
  function add(id, qty, props) { var it = { id: +id, quantity: qty || 1 }; if (props) it.properties = props; return post('/cart/add.js', { items: [it] }); }
  function toast(t) { var e = document.createElement('div'); e.className = 'nv-toast'; e.textContent = t; document.body.appendChild(e); setTimeout(function () { e.remove(); }, 3500); }
  var ERR = 'Non è stato possibile aggiungere il prodotto. Riprova.';

  /* ---- minuteur : 1 minute en boucle, l'etat survit aux rafraichissements du tiroir ---- */
  var left = null, tInt = null;
  function timer() {
    var el = $('#CartDrawer [data-nv-timer]'); if (!el) { left = null; return; }
    var total = (+el.getAttribute('data-min') || 1) * 60;
    if (left === null) {
      var fin = 0; try { fin = +sessionStorage.getItem('nv_tfin') || 0; } catch (e) {}
      if (!fin) { fin = Date.now() + total * 1000; try { sessionStorage.setItem('nv_tfin', String(fin)); } catch (e) {} }
      left = Math.round((fin - Date.now()) / 1000);
    }
    if (left <= 0) { el.remove(); return; }
    var v0 = $('[data-nv-timer-v]', el); if (v0) v0.textContent = Math.floor(left / 60) + ':' + (left % 60 < 10 ? '0' : '') + (left % 60);
    if (tInt) return;
    tInt = setInterval(function () {
      if (document.hidden) return;
      var e = $('#CartDrawer [data-nv-timer]'); if (!e) { clearInterval(tInt); tInt = null; left = null; return; }
      left--; if (left <= 0) { clearInterval(tInt); tInt = null; e.remove(); return; }
      var v = $('[data-nv-timer-v]', e), m = Math.floor(left / 60), s = left % 60;
      if (v) { var txt = m + ':' + (s < 10 ? '0' : '') + s; if (v.firstChild && v.firstChild.nodeType === 3) v.firstChild.nodeValue = txt; else v.textContent = txt; }
    }, 1000);
  }

  /* ---- upsells : photo par couleur, taille du reggiseno preselectionnee ---- */
  function upImg(card) {
    var sel = $('[data-nv-up-sel]', card), img = $('[data-nv-up-img]', card); if (!sel || !img) return;
    var map = {}; try { map = JSON.parse(card.getAttribute('data-imgmap') || '{}'); } catch (e) {}
    var o = sel.options[sel.selectedIndex], c = o && o.getAttribute('data-color'), src = c && map[c];
    if (src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
  }
  function upSize() {
    if (window.__nvUpTouched) return;
    var w = $('#CartDrawer [data-nv-upsell]'), sz = w && (w.getAttribute('data-bra-size') || '').toUpperCase(); if (!sz) return;
    $$('[data-nv-up]', w).forEach(function (card) {
      var sel = $('[data-nv-up-sel]', card); if (!sel) return;
      var cur = sel.options[sel.selectedIndex], c = cur && cur.getAttribute('data-color'), idx = -1;
      [].forEach.call(sel.options, function (o, i) { if (idx < 0 && !o.disabled && o.getAttribute('data-color') === c && (o.getAttribute('data-size') || '').toUpperCase() === sz) idx = i; });
      if (idx >= 0 && sel.selectedIndex !== idx) sel.selectedIndex = idx;
      upImg(card);
    });
  }

  var ITEMS = null, ITEMS_AT = 0;
  function readItems() {
    try { var j = $('#CartDrawer [data-nv-cart-keys]'); ITEMS = j ? JSON.parse(j.textContent || '[]') : null; ITEMS_AT = Date.now(); } catch (e) { ITEMS = null; }
    var d = dlg(); if (d && d.hasAttribute('data-count')) badge(d.getAttribute('data-count'));
  }
  /* cadeaux a 0 EUR orphelins : moins de 4 reggiseni dans le panier = on retire les cadeaux de lot */
  function dropOrphanGifts() {
    if (!ITEMS) return Promise.resolve();
    var bras = 0, gifts = []; ITEMS.forEach(function (i) { if (i.h === 'reggiseno-comfort-nuvella') bras += (i.q || 1); if (i.g) gifts.push(i.k); });
    if (bras >= 4 || !gifts.length) return Promise.resolve();
    var u = {}; gifts.forEach(function (k) { u[k] = 0; });
    return post('/cart/update.js', { updates: u }).catch(function () {});
  }
  function openNow() { var d = dlg(); if (!d) return; d.classList.add('is-loading'); open(); }
  function init() {
    var d = dlg(); if (!d) return;
    readItems(); timer(); upSize(); $$('[data-nv-up]', d).forEach(upImg);
  }

  /* ---- evenements (delegation : le contenu du tiroir est remplace a chaque rafraichissement) ---- */
  document.addEventListener('click', function (e) {
    var d = dlg(); if (!d) return;
    var t = e.target;
    if (t.closest && t.closest('#CartDrawer [data-close]')) { e.preventDefault(); close(); return; }
    var rm = t.closest && t.closest('#CartDrawer [data-nv-remove]');
    if (rm) { e.preventDefault(); var it = rm.closest('[data-key]'); if (!it) return; it.style.opacity = '.4'; var k0 = it.getAttribute('data-key'); change(k0, 0).then(function () { if (ITEMS) ITEMS = ITEMS.filter(function (i) { return i.k !== k0; }); return dropOrphanGifts(); }).then(function () { refresh(false); }, function () { it.style.opacity = ''; }); return; }
    /* compteur − n + (façon Siléor, 29/10) : agit sur la quantite totale de la ligne ; a 0 la ligne part ;
       moins de 4 reggiseni = les cadeaux de lot partent aussi (dropOrphanGifts) */
    var st = t.closest && t.closest('#CartDrawer [data-nv-minus], #CartDrawer [data-nv-plus]');
    if (st) {
      e.preventDefault(); var row = st.closest('[data-key]'), stp = st.closest('[data-nv-stp]'); if (!row || stp.classList.contains('is-busy')) return;
      var key = row.getAttribute('data-key'), q = +row.getAttribute('data-q') || 1, nq = st.hasAttribute('data-nv-plus') ? q + 1 : q - 1;
      if (nq > 10) return; stp.classList.add('is-busy'); if (nq <= 0) row.style.opacity = '.4';
      change(key, nq).then(function () { if (ITEMS) ITEMS.forEach(function (i) { if (i.k === key) i.q = nq; }); if (nq <= 0 && ITEMS) ITEMS = ITEMS.filter(function (i) { return i.k !== key; }); return dropOrphanGifts(); }).then(function () { refresh(false); }, function () { stp.classList.remove('is-busy'); row.style.opacity = ''; toast(ERR); refresh(false); });
      return;
    }
    /* interrupteur upsell : ON = ajout de la variante choisie, OFF = retrait de la ligne de ce produit */
    var sw = t.closest && t.closest('#CartDrawer [data-nv-up-toggle]');
    if (sw) {
      e.preventDefault(); var card = sw.closest('[data-nv-up]'); if (!card || card.classList.contains('is-busy')) return;
      card.classList.add('is-busy');
      var inKey = card.getAttribute('data-in-key'), sel = $('[data-nv-up-sel]', card);
      var pr = inKey ? change(inKey, 0) : (sel && sel.value ? add(sel.value, 1) : Promise.reject());
      pr.then(function () { return refresh(false); }).then(function () { card.classList.remove('is-busy'); }, function () { card.classList.remove('is-busy'); toast(ERR); });
      return;
    }
    var ed = t.closest && t.closest('#CartDrawer [data-nv-edit]');
    if (ed) { e.preventDefault(); close(); var nb = $('nv-bundle[data-nv-bundle]'); if (nb) setTimeout(function () { try { nb.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {} }, 150); else location.href = '/products/reggiseno-comfort-nuvella'; return; }
    if (t.closest && t.closest('#CartDrawer') && e.target === d) { close(); return; }
    /* liens /cart et icone sac : le tiroir, pas la page Carrello */
    var a = t.closest && t.closest('a[href$="/cart"]');
    if (a && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && d) { e.preventDefault(); refresh(true); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('#CartDrawer')) return;
    if (t.matches('[data-nv-up-sel]')) { if (e.isTrusted) window.__nvUpTouched = true; upImg(t.closest('[data-nv-up]')); return; }
    if (t.matches('[data-nv-swap]')) {
      var it = t.closest('[data-key]'), key = it && it.getAttribute('data-key'), id = +t.value; if (!key || !id) return;
      it.style.opacity = '.4';
      change(key, 0).then(function () { return add(id, 1); }).then(function () { refresh(false); }, function () { it.style.opacity = ''; toast(ERR); refresh(false); });
    }
  }, true);
  /* theme.js remplace aussi le contenu (#CartDrawer innerHTML) apres ses propres ajouts : on se re-initialise */
  var mo = null;
  function watch() { var d = dlg(); if (!d || mo) return; mo = new MutationObserver(function () { init(); }); mo.observe(d, { childList: true }); }
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { badgeFromApi(); refresh(false); } });
  function start() { init(); watch(); badgeFromApi(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.nvCart = { refresh: refresh, refreshFromHtml: refreshFromHtml, open: function () { refresh(true); }, openNow: openNow, close: close, isOpen: isOpen, items: function () { return ITEMS; }, itemsAge: function () { return ITEMS ? Date.now() - ITEMS_AT : Infinity; } };
  window.opusOpen = function () { refresh(true); };
})();
